import _ from "underscore";
import join from "nllib/src/uri/join";
import get_url_prefix from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_url_prefix";

import LoginCore from "yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/login-core/1.0.1/index.vue";
// 获取定位城市
import get_local_city from "@/lib/common-service/get_local_city/index.js";

// 通过ip获取定位城市
import web_common_TourismMall_getArea from "@/lib/data-service/default/web_common_TourismMall_getArea";

// 首推产品列表
import get_recommend_productList from "@/lib/data-service/default/web_common_TourismMall_ediTourismList";
// 分类管理产品列表
// import get_productList from "@/lib/data-service/default/web_common_TourismMall_tourismProductList";

// 轮播图
import web_common_advert_showList from "@/lib/data-service/default/web_common_advert_showList";

// 用户注册信息
// import get_user_info from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_user_info";

export default {
  components: {
    LoginCore, //登录组件
  },
  data() {
    return {
      loading: false,

      //轮播图数据
      slideDatas: {
        waitSecond: 10, //图片停留时间seconds
        list: [],
      },
      // 待付款数据
      obligationsDatas: [],

      // 公告数据
      notificationDatas: [],
      // 热门城市
      hotCity_list: [
        {
          cityId: "110000",
          cityName: "北京",
        },
        {
          cityId: "120100",
          cityName: "天津",
        },
        {
          cityId: "110000",
          cityName: "北京",
        },
        {
          cityId: "120100",
          cityName: "天津",
        },
        {
          cityId: "110000",
          cityName: "北京",
        },
        {
          cityId: "120100",
          cityName: "天津",
        },
      ],
      // 特供产品
      specialProductsDatas: {},

      // 热门推荐产品
      recommendDatas: [],
      // 分类产品列表
      // classifyProductDatas: [],

      classifyTabList: [],

      // userInfo: {},
    };
  },
  methods: {
    // 请求轮播图
    req_slide() {
      return new Promise((resolve, reject) => {
        web_common_advert_showList({ advertPictureType: 2 })
          .then((result) => {
            this.slideDatas = result;
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 请求产品列表
    // req_product_list(city) {
    //   // cityName出发城市，firstNum首推产品数量，otherNum跟团游等的数量，searchType需要请求那些
    //   return new Promise((resolve, reject) => {
    //     get_productList({
    //       fromCityName: city.cityName,
    //       fromCityId: city.cityId,
    //       firstNum: 4,
    //       otherNum: 8,
    //       searchType: "",
    //     })
    //       .then((result) => {
    //         let datas = [];

    //         const needManagementType = [1, 2, 3];

    //         result.tourismProductResultList.forEach((item) => {
    //           if (needManagementType.includes(item.managementType))
    //             datas.push({ ...item });
    //         });

    //         for (let i = 0; i < datas.length; i++) {
    //           const list = datas[i].tourismProductClassifieList;
    //           for (let j = 0; j < list.length; j++) {
    //             const arr = list[j].solrProductList;
    //             for (let k = 0; k < arr.length; k++) {
    //               const item = arr[k];
    //               if (!item.productPicture) item.productPicture = "";
    //             }
    //           }
    //         }

    //         let list = [];
    //         for (var i = 0; i < datas.length; i++) {
    //           const item = datas[i];
    //           if (item.managementType !== 0) {
    //             list.push(item);
    //             this.classifyTabList.push(0);
    //           }
    //         }
    //         this.classifyProductDatas = list;
    //         resolve(reject);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
    // 请求首推产品列表city
    req_recommend_product_list() {
      return new Promise((resolve, reject) => {
        get_recommend_productList({
          // fromCityName: city.cityName,
          // fromCityId: city.cityId,
          firstNum: 4,
        })
          .then((result) => {
            const datas = result.ediHomeTourismResultList;

            for (let i = 0; i < datas.length; i++) {
              const list = datas[i].ediTourismList;
              for (let j = 0; j < list.length; j++) {
                const item = list[j];
                if (!item.productPicture) {
                  item.productPicture = '';
                } else {
                  item.productPicture = item.productPicture.split('$$').join(',');
                }
              }
            }

            datas.forEach((item) => {
              item.ediTourismList = item.ediTourismList.splice(0, 4);
            });

            this.recommendDatas = datas;
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 请求各个数据city
    req_datas() {
      Promise.all([
        // this.req_product_list(city), // 请求旅游产品
        // this.req_recommend_product_list(city), // 请求首推产品列表
        this.req_recommend_product_list(), // 请求首推产品列表
        this.req_slide(), // 轮播图
      ])
        .then((result) => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 初始化
    init() {
      this.loading = true;

      this.$refs.aLoginCore.init({
        login_successfully_event_handler(data) {
          const token = data.token;
          const userType = data.userType;

          // 供应商
          if (_.contains([1, 2], userType)) {
            const url_prefix = get_url_prefix({
              appKey: `frontend-supplier`,
            });
            const url = join(
              url_prefix,
              `redirect/?redirectType=000&token=${token}`
            );
            window.location.href = url;
            return;
          }

          // 分销商
          if (_.contains([3, 4, 7], userType)) {
            const url_prefix = get_url_prefix({
              appKey: `frontend-distributor`,
            });

            const url = `${url_prefix}/redirect?redirectType=100&token=${token}`;

            window.open(url, "_self");
            return;
          }

          // 平台
          if (_.contains([5], userType)) {
            const url_prefix = get_url_prefix({
              appKey: `frontend-platform`,
            });
            const url = join(
              url_prefix,
              `redirect/?redirectType=000&token=${token}`
            );
            window.location.href = url;
            return;
          }

          // 游客
          if (_.contains([6], userType)) {
            const url = `/general-user`;
            window.location.href = url;
            return;
          }
        },
      });
      this.req_datas();

      // 获取帐号信息
      // get_user_info().then((res) => {
      //   this.userInfo = res;
      // });
      // const localCity = get_local_city();
      // if (localCity.cityName) {
      //   this.req_datas(localCity);
      // } else {
      //   web_common_TourismMall_getArea()
      //     .then((result) => {
      //       this.req_datas({
      //         cityName: result.cityName,
      //         cityId: result.areaId,
      //       });
      //     })
      //     .catch((err) => {
      //       this.loading = false;
      //     });
      // }
    },

    __btn_distributor_registration_click() {
      this.$router.push({
        name: `distributor-registration`,
      });
    },
    __btn_supplier_registration_click() {
      this.$router.push({
        name: `supplier-registration`,
      });
    },
    // 点击旅游产品管理分类侧边图去搜索
    click_managementType_image(managementType) {
      this.$router.push({
        name: "distributor-tour-front-search",
        query: {
          managementType,
        },
      });
    },

    // 当点击轮播图
    click_swiper(item) {
      return;
      // advertForwardType跳转方式 0：无链接    1：关键字(不带城市)     2：按关键字(带城市)     3：按关键字(带注册城市)    4：按链接     5：按照产品编号搜索   现在是这样的
      const {
        advertForwardType, //跳转方式
        advertLink, //跳转链接
        productNo, //产品编号
        advertKeyword, //关键字
        areaId, //城市id
        areaName, //城市名称
      } = item;

      const jump = (query) => {
        this.$router.push({
          name: "distributor-tour-front-search",
          query,
        });
      };

      switch (advertForwardType) {
        case 0:
          break;
        case 1:
          jump({ travelKeywords: advertKeyword, is_auto_add_city: false });
          break;
        case 2:
          jump({
            travelKeywords: advertKeyword,
            is_auto_add_city: false,
            fromCityId: areaId,
            fromCityName: areaName,
          });
          break;
        case 3:
          jump({
            travelKeywords: advertKeyword,
            is_auto_add_city: true,
          });
          break;
        case 4:
          window.open(advertLink, "_blank");
          break;
        case 5:
          this.to_detail(productNo);
          break;
      }
    },

    // 点击推荐部分去搜索页
    recommend_to_more() {
      this.$router.push({
        name: "distributor-tour-front-search",
      });
    },

    // 管理分类去搜索
    more_to_search(managementType) {
      let query = { managementType };
      if ([3].includes(managementType)) query.is_auto_add_city = false;
      this.$router.push({
        name: "distributor-tour-front-search",
        query,
      });
    },

    // 改变管理分类的tab
    change_tab(index, i) {
      this.$set(this.classifyTabList, index, i);
    },

    to_detail_use_id(id, productNo) {
      const { href } = this.$router.resolve({
        name: "distributor-tour-front-details",
        query: {
          id,
          productNo,
        },
      });
      window.open(href, "_blank");
    },

    to_detail(productNo) {
      const { href } = this.$router.resolve({
        name: "distributor-tour-front-details",
        query: {
          productNo,
        },
      });
      window.open(href, "_blank");
    },

    to_login() {
      this.$router.push({
        name: "login",
      });
    },
  },
  filters: {},
  created() {},
  mounted() {
    this.init();
  },
};
